// ----------------------------------------------------------------------

export default function Input(theme) {
  return {
    MuiInputBase: {
      styleOverrides: {
            root: {
              backgroundColor: '#F3F3F5',
          '&.Mui-disabled': {
            '& svg': { color: theme.palette.text.disabled },
          },
        },
            input: {
                backgroundColor: '#F3F3F5',
          '&::placeholder': {
            opacity: 1,
            color: theme.palette.text.disabled,
          },
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          '&:before': {
            borderBottomColor: theme.palette.grey[500_56],
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
              // backgroundColor: theme.palette.grey[500_12],
              backgroundColor: '#F3F3F5',
          '&:hover': {
              // backgroundColor: theme.palette.grey[500_16],
              backgroundColor: '#F3F3F5',
          },
          '&.Mui-focused': {
            backgroundColor: theme.palette.action.focus,
          },
          '&.Mui-disabled': {
            backgroundColor: theme.palette.action.disabledBackground,
          },
        },
        underline: {
          '&:before': {
            borderBottomColor: theme.palette.grey[500_56],
          },
        },
      },
    },
    // MuiOutlinedInput: {
    //  styleOverrides: {
    //        root: {
    //          backgroundColor: '#F3F3F5',
    //      '& .MuiOutlinedInput-notchedOutline': {
    //        borderColor: theme.palette.grey[500_32],
    //      },
    //      '&.Mui-disabled': {
    //        '& .MuiOutlinedInput-notchedOutline': {
    //          borderColor: theme.palette.action.disabledBackground,
    //        },
    //      },
    //    },
    //  },
      // },
      MuiOutlinedInput: {
          styleOverrides: {
              root: {
                  backgroundColor: '#F3F3F5',
                  '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#E5E5E5',
                      borderWidth: '1px', // force 1px always
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#E5E5E5',
                      borderWidth: '1px', // no thickening on hover
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#E5E5E5',
                      borderWidth: '1px', // no thickening on focus
                  },
                  '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#E5E5E5', // keep border same when disabled
                  },
                  '&.Mui-disabled:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#E5E5E5', // prevent hover effect on disabled
                  },
              },
          },
      },
  };
}
